export default __webpack_public_path__ + "static/media/cal_bg7.ce706f6f.jpg";